jQuery.validator.addMethod(
    'notEqual',
    function (value, element, param) {
      return this.optional(element) || value != $(param).val()
    },
    'No te puedes referenciar a ti mismo...'
  );
  


$(function () {
    $("#form-account").validate({       
        rules: {
            Identification:{
                required: true,
                minlength : 9,
                maxlength: 30
            },
            Mail: {
                email: true
            },
            MailConfirm: {
                equalTo: '#Mail'
            },
            name: {
                required: true,
                minlength: 3
            },  
            Password : {
                minlength : 3,
                maxlength: 50,
                required: true,
            },
            ConfirmPassword : {
                minlength : 3,
                maxlength: 50,
                equalTo : "#Password"
            },
            referencia: {
                notEqual: '#cedula',
                minlength : 9,
                maxlength: 30,
            },
            Phone: {
                minlength : 3,
                maxlength: 30,
            },             
        },
        submitHandler: function(form){ CreateAccount(form) }
    });

    $('#cedula, #referencia').bind('keyup paste', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
      });
});


function CreateAccount(form) {
    if(!$('#terms').is(':checked')){
        Swal.fire({
            icon: 'error',
            title: 'Terminos',
            text: 'Por favor aceptar los términos y condiciones antes de continuar',
            confirmButtonColor: "#001f3f",
        });
        return;
    }

    $('#submitregister').prop('disabled',true);
    form.submit();
}

